import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
function isDesignsBundleObject(config) {
    if (typeof config === 'object' &&
        config !== null &&
        Object.hasOwn(config, 'designs') &&
        !Array.isArray(config)) {
        const configCast = config;
        const designsCast = configCast.designs;
        return typeof designsCast.classic === 'object';
    }
    return false;
}
function parseDesigns(input) {
    if (!input?.trim()) {
        return undefined;
    }
    try {
        const parsedDesigns = JSON.parse(input);
        if (!isDesignsBundleObject(parsedDesigns)) {
            throw Error(`Config object does not contain a valid design bundle`);
        }
        return parsedDesigns.designs;
    }
    catch (e) {
        throw Error(`Unexpected: ${e}`);
    }
}
function splitConfigFromContent(content) {
    const { 'feature-app-config': config, ...otherFields } = content.fields;
    return {
        config,
        content: {
            ...content,
            fields: otherFields,
        },
    };
}
function parseCss(cssString) {
    let transformedCss = [];
    if (typeof cssString === 'undefined') {
        return transformedCss;
    }
    if (!Array.isArray(cssString)) {
        try {
            const parsedCss = JSON.parse(cssString);
            if (Array.isArray(parsedCss)) {
                transformedCss = parsedCss.map((singleCssValue) => {
                    if (typeof singleCssValue === 'string') {
                        return { href: singleCssValue };
                    }
                    return singleCssValue;
                });
            }
        }
        catch (error) {
            throw Error('The Feature App CSS contains invalid JSON in Content Fragment Model.');
        }
    }
    return transformedCss;
}
export const FeatureApp = ({ index, owner, app, id, designSystem, logger, }) => {
    const { baseUrl, src, serverSrc, config: designSystemConfig, css, } = app.model.metadata;
    const { config, content: rawContent } = splitConfigFromContent(app);
    let designs;
    try {
        designs = parseDesigns(designSystemConfig);
    }
    catch (error) {
        if (logger) {
            logger.error(error.message, {
                appStoreId: id,
            });
        }
    }
    let parsedCss = [];
    try {
        parsedCss = parseCss(css);
    }
    catch (error) {
        if (logger) {
            logger.error(error.message, {
                appStoreId: id,
            });
        }
    }
    const isAlphaMode = designSystem === 'alpha';
    const isAlphaReady = typeof designs?.classic === 'object';
    const isAlphaOnly = designs?.classic === null;
    const clientSideBundleSrc = (() => {
        if (isAlphaMode && isAlphaReady) {
            return src;
        }
        if (isAlphaMode) {
            if (logger) {
                logger.error('Trying to render feature-app via Spawn Component in alpha design, but it does not support alpha.', {
                    appStoreId: id,
                });
            }
            return '';
        }
        if (isAlphaReady && isAlphaOnly) {
            if (logger) {
                logger.error('Trying to render feature-app via Spawn Component in classic design, but this app supports alpha only.', {
                    appStoreId: id,
                });
            }
            return '';
        }
        if (isAlphaReady) {
            if (typeof designs?.classic?.clientSideBundleUrl === 'string') {
                return designs?.classic?.clientSideBundleUrl;
            }
        }
        return src;
    })();
    const getServerSource = () => {
        if (isAlphaMode && isAlphaReady) {
            return serverSrc;
        }
        if (isAlphaReady) {
            return designs?.classic?.serverSideBundleUrl;
        }
        return serverSrc;
    };
    const hasClientSideBundleSrc = !!clientSideBundleSrc.trim();
    const beforeCreate = (env) => {
        const contentService = env.featureServices['audi-content-service'];
        if (contentService) {
            contentService.setContent(rawContent);
        }
        const trackingService = env.featureServices['audi-tracking-service'];
        if (trackingService && owner && index) {
            trackingService.asChildOf(owner, index);
        }
    };
    return (hasClientSideBundleSrc && (React.createElement(FeatureAppLoader, { featureAppId: id, baseUrl: baseUrl, src: clientSideBundleSrc, serverSrc: getServerSource(), css: parsedCss, config: config
            ? {
                __type: 'aem-headless',
                config,
            }
            : undefined, beforeCreate: beforeCreate })));
};
FeatureApp.displayName = 'FeatureApp';
//# sourceMappingURL=feature-app.js.map